import { render, staticRenderFns } from "./TourList.vue?vue&type=template&id=3b735a09"
import script from "./TourList.vue?vue&type=script&lang=js"
export * from "./TourList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports